import { useEffect, useState } from 'react';
import instance from 'api/instance';
import { EnlaceData } from '@componentes/Tabla/types';
import useToggle from '@utils/useToggle';
import TablaEspecial from '@componentes/TablaEspecial/TablaEspecial';

export default function EnlacesInteres() {
    const [enlaces, setEnlaces] = useState<{ id: number, descripcion: string }[]>([])
    const [configLoaded, setConfigLoaded] = useToggle(false);
    const [apiUrlConfig, setApiUrlConfig] = useState('');
    const [links, setLinks] = useState<{ id: number, descripcion: string, link: string, icon: boolean }[]>([])

    useEffect(() => {
        // Cargar el config.json desde la carpeta public
        const loadConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setLinks(config.ANEXOS)
                setApiUrlConfig(config["API_URL"]);
                if (setConfigLoaded) {
                  setConfigLoaded(true);
                }
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (configLoaded) {
            const fetchData = async () => {
                const apiUrl = `${apiUrlConfig}obtenerDatosEnlace`;
                instance
                    .get<EnlaceData[]>(apiUrl)
                    .then((response) => {
                        const data = response.data.map((ele, index) => {
                            return {
                                id: index,
                                descripcion: ele.DESCRIPCION,
                                enlace: ele.ENLACE
                            }
                        }
                        )
                        setEnlaces(data);
                    })
                    .catch((error) => {
                        console.error("Error al hacer la solicitud:", error);
                    });
            };

            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configLoaded, apiUrlConfig]);

    return (
        <div className="enlaces-interes" style={{ width: '100%', marginBottom: '2%' }}>
            {
                enlaces && <TablaEspecial info={enlaces} tipo='Enlaces de Interés' />
            }
            {
                links && <TablaEspecial info={links} tipo='Anexos ZBE' />
            }
        </div>
    );
}